import withStyles from "react-jss"
import AuthenticateUser from "./AuthenticateUser"
import styles from './AuthenticateUser.styles'

export default withStyles(styles)(AuthenticateUser)
